import { SpecArtifactsPageContent } from '@squareup/dex-tech-specification-artifacts-page-content';
import { DocsPageContentLayout } from '@squareup/dex-ui-dex-tech-docs-page-layout';

import { DocsBasePage, DocsBasePageProps } from '../../../shared/DocsBasePage';

const Page = () => {
  return (
    <DocsPageContentLayout>
      <SpecArtifactsPageContent />
    </DocsPageContentLayout>
  );
};

const WrapperPage = (data: DocsBasePageProps) => {
  return (
    <DocsBasePage {...data}>
      <Page />
    </DocsBasePage>
  );
};

export default WrapperPage;
